import { Dispatch } from 'react';
import api from 'src/api/api';
import { HEADERS } from 'src/constants/headers';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { CREATE_STORE_GROUP } from '../constants/actions';
import { TStoreGroupActionTypes } from '../types';
import { IStoreGroup } from 'src/interfaces/storeGroup';

/**
 * Will create a store group
 *
 * @param {Dispatch<TStoreGroupActionTypes>} dispatch
 * @param {Partial<IStoreGroup>} storeGroup
 */
export const createStoreGroup = async (
    dispatch: Dispatch<TStoreGroupActionTypes>,
    storeGroup: Partial<IStoreGroup>
) => {
    dispatch({ type: SET_LOADING });
    try {
        const res = await api.post(
            `/store-groups`,
            { ...storeGroup },
            HEADERS()
        );
        dispatch({ type: CREATE_STORE_GROUP, payload: res.data.data });
    } catch (error) {
        dispatch(handleError(error));
    }
};
